export default __webpack_public_path__ + "static/media/siemens-logo-white.3c8b4f71.svg";